
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import {pathConstants} from "../../../shared/pathConstants";
import Vue from "vue";

export const precarityService = {
    fetchPrecarity
};

function fetchPrecarity(periodId, departmentCode) {
    return axios.get(pathConstants.API + `/precarite/period/${periodId}/department/${departmentCode}`,
        {showLoader: false})
        .then(result => {
                return result.data;
            }, err => {
            Vue.$log.error("fetchPrecarity", err);
            }
        );
}
